"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));

var _styled = require("../Message/styled");

var MessageSkeleton = function MessageSkeleton() {
  return /*#__PURE__*/_react["default"].createElement(_styled.Container, null, /*#__PURE__*/_react["default"].createElement(_reactLoadingSkeleton["default"], {
    circle: true,
    height: 35,
    width: 35,
    style: {
      marginRight: 12
    }
  }), /*#__PURE__*/_react["default"].createElement(_styled.Contents, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactLoadingSkeleton["default"], {
    count: 3
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "100px",
      marginLeft: 12,
      marginTop: -6
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactLoadingSkeleton["default"], {
    count: 1,
    height: 20
  })));
};

var Loading = function Loading() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(MessageSkeleton, null), /*#__PURE__*/_react["default"].createElement(MessageSkeleton, null), /*#__PURE__*/_react["default"].createElement(MessageSkeleton, null), /*#__PURE__*/_react["default"].createElement(MessageSkeleton, null), /*#__PURE__*/_react["default"].createElement(MessageSkeleton, null), /*#__PURE__*/_react["default"].createElement(MessageSkeleton, null));
};

var _default = Loading;
exports["default"] = _default;